export function isIFormationMetaObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function isIFormationMetaArray(value) {
    return Array.isArray(value);
}
export { isIFormationMetaArray as isIArray, isIFormationMetaObject as isIObject, };
//# sourceMappingURL=IMeta.js.map